import { c as _c } from "react-compiler-runtime";
import { useCallback, useMemo, memo } from 'react';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { useSelectionDispatch, useSelectionSelector } from '../../redux/reduxHooks';
import { getSelectedRowIds, setRowsSelected } from '../redux/selectionSlice';
import I18n from 'I18n';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const SelectAllCheckboxHeader = t0 => {
  const $ = _c(11);
  const {
    rowIds
  } = t0;
  const selectedRowIds = useSelectionSelector(getSelectedRowIds);
  let t1;
  if ($[0] !== rowIds || $[1] !== selectedRowIds) {
    t1 = rowIds.length > 0 && rowIds.every(rowId => selectedRowIds.has(rowId));
    $[0] = rowIds;
    $[1] = selectedRowIds;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isCurrentPageSelected = t1;
  const dispatch = useSelectionDispatch();
  let t2;
  if ($[3] !== dispatch || $[4] !== rowIds) {
    t2 = t3 => {
      const {
        target: t4
      } = t3;
      const {
        checked
      } = t4;
      dispatch(setRowsSelected(rowIds.map(rowId_0 => ({
        rowId: rowId_0,
        selected: checked
      }))));
    };
    $[3] = dispatch;
    $[4] = rowIds;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleChange = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = I18n.text("datatable.bulkActions.selectAllCheckboxLabel");
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = selectedRowIds.size > 0;
  let t5;
  if ($[7] !== handleChange || $[8] !== isCurrentPageSelected || $[9] !== t4) {
    t5 = /*#__PURE__*/_jsx("th", {
      scope: "col",
      "data-test-id": "checkbox-select-all-container",
      "data-selection-column": true,
      children: /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        justifyContent: "center",
        flexGrow: 1,
        children: /*#__PURE__*/_jsx(Checkbox, {
          "aria-label": t3,
          "data-test-id": "checkbox-select-all",
          checked: isCurrentPageSelected,
          indeterminate: t4,
          onChange: handleChange
        })
      })
    });
    $[7] = handleChange;
    $[8] = isCurrentPageSelected;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default /*#__PURE__*/memo(SelectAllCheckboxHeader);